// Confirmation summary panel — used by /payment/success (Stripe) and
// /thank-you (PayPal). Takes a normalised status object:
//   { product_title, amount, currency, booking: { ...BookingDetails } }
// and renders a calm, cinematic breakdown of what was bought + the
// captured class / contact info.

const ROWS = [
  { key: "class_type", label: "Class" },
  { key: "location", label: "Location" },
  { key: "preferred_day", label: "Day" },
  { key: "preferred_time", label: "Time" },
  { key: "age_group", label: "Age group" },
  { key: "student_name", label: "Student" },
  { key: "guardian_name", label: "Guardian" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "notes", label: "Notes" },
];

export const BookingSummaryCard = ({ status }) => {
  if (!status) return null;
  const b = status.booking || {};
  const visibleRows = ROWS.filter((r) => (b[r.key] || "").toString().trim().length > 0);
  if (!status.product_title && visibleRows.length === 0) return null;

  return (
    <div
      data-testid="booking-summary-card"
      className="mt-8 mx-auto max-w-xl text-left rounded-3xl border border-white/10 bg-gradient-to-br from-brand-purpleDeep/30 to-zinc-950 p-6 sm:p-7"
    >
      <div className="text-[10px] uppercase tracking-[0.32em] text-brand-yellow mb-3">Booking summary</div>

      {status.product_title && (
        <div className="flex items-start justify-between gap-4 pb-4 mb-4 border-b border-white/10">
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Item</div>
            <div className="font-display text-xl text-white tracking-wide leading-tight">{status.product_title}</div>
          </div>
          {typeof status.amount === "number" && (
            <div className="text-right">
              <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">Paid</div>
              <div className="font-display text-xl text-brand-yellow tracking-wide">
                £{Number(status.amount).toFixed(Number(status.amount) % 1 ? 2 : 0)}
              </div>
            </div>
          )}
        </div>
      )}

      {visibleRows.length > 0 ? (
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          {visibleRows.map((r) => (
            <div key={r.key} data-testid={`booking-summary-${r.key}`}>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">{r.label}</dt>
              <dd className="text-sm text-white mt-0.5 whitespace-pre-line">{b[r.key]}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="text-xs text-zinc-400">
          We've logged your purchase against your account email — we'll be in touch with the next steps.
        </p>
      )}
    </div>
  );
};
